import { isVideoSegment, type Segment } from "@memento/types/segment";

export type VideoSource = {
  src: string;
  type: "video/mp4" | "video/webm; codecs=vp9,vorbis";
};

export function getSegmentSources(segment: Segment): VideoSource[] {
  const videoCdnSources: VideoSource[] =
    isVideoSegment(segment) && segment.videoCdnUrl
      ? [
          {
            src: segment.videoCdnUrl,
            type: "video/mp4",
          },
        ]
      : !isVideoSegment(segment) && segment.urls
        ? segment.urls.map((url) => ({ src: url, type: "video/mp4" }))
        : [];

  return [
    ...videoCdnSources,
    {
      src:
        (isVideoSegment(segment) && segment.videoCdnUrl
          ? segment.videoUrl
          : !isVideoSegment(segment) && segment.urls
            ? segment.urls[0]
            : "") || "",
      type: "video/mp4",
    },
  ];
}
